module.exports = __webpack_public_path__ + "img/lagerausbildung-2bohrungen-en.8086516e.png";